"use client";

import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { isLocalTestPage, readLocalTestAccount } from "./local-test-account-client";

type Account = { identity: string; label: string; email: string };
export function LocalTestAccounts({ next, helperToken, selectedIdentity }: { next: string; helperToken: string; selectedIdentity?: string }) {
  const router = useRouter();
  const [accounts, setAccounts] = useState<Account[]>([]);
  useEffect(() => {
    if (!helperToken || !isLocalTestPage()) return;
    const controller = new AbortController();
    void readLocalTestAccount<Account[]>("accounts", helperToken, {}, controller.signal).then(setAccounts).catch(() => {});
    return () => controller.abort();
  }, [helperToken]);
  if (!accounts.length) return null;
  return <label className="auth-login-test-account flex items-center gap-3">
    <span className="text-sm font-medium">测试</span>
    <select aria-label="测试账号" value={accounts.some(account => account.identity === selectedIdentity) ? selectedIdentity : "creator"}
      onChange={event => {
        const identity = event.target.value;
        if (accounts.some(account => account.identity === identity)) router.push(`/login?${new URLSearchParams({ method: "email", testAccount: identity, next })}`);
      }}
      className="min-w-0 flex-1 rounded-xl border border-[var(--color-line-strong)] bg-[var(--color-sunken)] px-3 py-2 text-sm text-[var(--color-paper)]">
      {accounts.map(account => <option key={account.identity} value={account.identity} className="bg-[var(--color-surface-2)] text-[var(--color-paper)]">{account.label}</option>)}
    </select>
  </label>;
}
